<script lang="ts" setup>
const { open } = useNavigationMobileModal()
</script>
<template>
  <HeaderActionButton class="mobile-only" @click="open">
    <Icon name="mobile-menu" />
  </HeaderActionButton>
  <ModalNavigationMobile />
</template>
